import styled from 'styled-components'

import main9bg from '@/assets/main/main9/main9bg.png'
import { customMedia } from '@/styles/common/common'

const Main9SectionWrap = styled.div`
  display: block;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-image: url(${main9bg});
  height: 863px;
  background-size: cover;
  text-align: center;
  max-width: 2560px;
  margin: 0 auto;
  > h3 {
    font-family: NanumSquareNeoExtraBold, sans-serif;
    font-size: 40px;
    line-height: 60px;
    margin: 156px auto 29px auto;
  }

  ${customMedia.lessThan('tablet')`
    height: 617px;
     >h3{
      font-size: 24px;
      line-height: 27px;  
      margin: 91px auto 41px auto;
     }
   `}
`

export { Main9SectionWrap }
